import _ from 'lodash'

export default class InputSpecs
  constructor: (@specs) ->

  allInputs: ->
    topLevel = _.filter(@specs, 'property')
    groups   = _.filter(@specs, 'group')

    _.concat(topLevel, _.flatMap(groups, 'inputs'))

  allProperties: ->
    _.map(@allInputs(), 'property')

  specFor: (property) ->
    _.find(@allInputs(@specs), property: property)

  addValidatorFor: (property, validator) ->
    @updateSpecFor(property, (spec) ->
      existingValidators = _.compact(_.flatten([spec.validator]))

      _.assign({}, spec, validator:_.concat(existingValidators, validator)))

  updateSpecFor: (property, updater) ->
    @mapInputSpecs (spec) ->
      if spec.property == property then updater(spec) else spec

  mapInputSpecs: (mapper) ->
    specs = @specs.map (spec) ->
      if spec.group then _.assign({}, spec, inputs: spec.inputs.map(mapper))
      else mapper(spec)

    new @constructor(specs)

  mapGroups: (mapper) ->
    specs = @specs.map (spec) -> if spec.group then mapper(spec) else spec

    new @constructor(specs)

  filterInputs: (matcher) ->
    specs = @specs.map (spec) ->
      if spec.group
        _.assign({}, spec, inputs: spec.inputs.filter(matcher))
      else
        matcher = if _.isFunction(matcher) then matcher else _.matches(matcher)

        matcher(spec) and spec

    new @constructor(_.reject(_.compact(specs), (spec) -> spec.group and not spec.inputs.length))

  rejectInputs: (matcher) ->
    matcher = if _.isFunction(matcher) then matcher else _.matches(matcher)

    @filterInputs(_.negate(matcher))

  filterGroups: (matcher) ->
    finalMatcher = (spec) ->
      not spec.group or if _.isFunction(matcher) then matcher(spec) else _.isMatch(spec, matcher)

    new @constructor(_.filter(@specs, finalMatcher))

  rejectGroups: (matcher) ->
    finalMatcher = (spec) ->
      not spec.group or not (if _.isFunction(matcher) then matcher(spec) else _.isMatch(spec, matcher))

    new @constructor(_.filter(@specs, finalMatcher))
